














import { defineComponent, PropType } from "@vue/composition-api";
import { UserReferring } from "@scrile/api-provider/dist/api/UserReferringProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import AvatarDescription from "@/components/AvatarDescription";
import InfiniteScroll from "@/components/InfiniteScroll";

export default defineComponent({
  name: "ReferralsList",
  components: { AvatarDescription, InfiniteScroll },
  props: {
    enableScroll: { type: Boolean, required: true },
    userReferrings: { type: Array as PropType<UserReferring[]>, required: true },
  },
  setup() {
    return {
      getProfileUrl,
    };
  },
});
